<template>
  <div
    v-if="mobileOpen"
    class="mobile-backdrop"
    @click="closeMobile"
  />
  <div 
    class="sidebar-style" 
    :class="{ 'mobile-open': mobileOpen }"
  >
    <h1>
      <span>
        <img
          class="logo" 
          src="../../assets/images/watercolor_logo.png"
        >
      </span>
    </h1>
    <SidebarLink 
      to="/subjectslist" 
      icon="fa-book-atlas"
    > 
      Library
    </SidebarLink> 
    <SidebarLink 
      to="/chat" 
      icon="feather"
    > 
      Chat
    </SidebarLink> 
    <SidebarLink 
      to="/vocabularylist" 
      icon="fa-school"
    > 
      Review
    </SidebarLink> 
    <div class="logout-spacer">
      <SidebarLink 
        to="/login" 
        icon="right-from-bracket"
        @click="logout()"
      > 
        Logout
      </SidebarLink>
    </div>
  </div>
</template>

<script>
import { mobileOpen } from './state';
import SidebarLink from './SidebarLink'

export default {
    components: { SidebarLink },
    props: {},
    setup() {
        return {
            mobileOpen
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        logout() {
            this.$store.dispatch('logout').then(() => {
              // Redirect to login page after successful logout
              this.$router.push({ path: '/login' });
            }).catch((err) => {
              throw err;
            });
        },
        handleResize() {
            if (window.innerWidth > 599) mobileOpen.value = false;
            this.$forceUpdate();
        },
        closeMobile() {
            mobileOpen.value = false;
        }
    }
}
</script>
<style>
:root {
  --sidebar-bg-color: #1a1f4e;
  --sidebar-item-hover: rgba(255, 255, 255, 0.18);
  --sidebar-item-active: rgba(255, 255, 255, 0.26);
}
</style>

<style scoped>
.logo {
  width: 70px;
  margin-top: 20px;
  margin-left: -2px;
  filter: drop-shadow(0 0 6px rgba(160, 180, 255, 0.5));
}

@media (max-width: 599px) {
  .logo {
    width: 26px;
    height: 26px;
  }
}

.space-adjustment {
  width: 230px;
  height: 81px;
}

.sidebar-style {
    color: white;
    background: linear-gradient(180deg, #2e3c8f 0%, #243070 60%, #1a2458 100%);
    width: 76px;
    float: left;
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    bottom: 0;
    padding: 0.6em 0.5em;

    display: flex;
    flex-direction: column;

    font-family: var(--font-family);
    border-right: 1px solid rgba(100, 120, 220, 0.25);
}

h1 {
    padding-bottom: 0.6em;
    margin-bottom: 0.4em;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.menu-item {
  text-align: center;
}


.logout-spacer {
    margin-top: auto;
}

.mobile-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 99;
}

@media (max-width: 599px) {
  .sidebar-style {
    width: 76px !important;
    transform: translateX(-76px);
    transition: transform 0.3s ease;
    z-index: 100;
  }
  .sidebar-style.mobile-open {
    transform: translateX(0);
  }
}
</style>

